import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useStyles } from "./WordCard.styles";

const WordCard = ({ word, featured }) => {
  const classes = useStyles();

  if (featured) {
    return (
      <div className={classes.featuredCard}>
        {word.image_url ? (
          <Link to={`/word/${encodeURIComponent(word.slug)}`}>
            <img
              src={word.image_url}
              alt={word.title}
              className={classes.featuredImage}
            />
          </Link>
        ) : null}
        <div className={classes.featuredContent}>
          <h2 className={classes.featuredTitle}>{word.title}</h2>
          {word.pronunciation ? (
            <p className={classes.featuredPronunciation}>
              [{word.pronunciation}]
            </p>
          ) : null}
          {word.definition ? (
            <p className={classes.featuredDefinition}>{word.definition}</p>
          ) : null}
          <Link
            to={`/word/${encodeURIComponent(word.slug)}`}
            className={classes.learnMoreLink}
          >
            Learn More →
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.card}>
      {word.image_url ? (
        <Link
          to={`/word/${encodeURIComponent(word.slug)}`}
          className={classes.learnMoreLink}
        >
          <img
            src={word.image_url}
            alt={word.title}
            loading="lazy"
            className={classes.cardImage}
          />
        </Link>
      ) : null}
      <div className={classes.cardContent}>
        <h3 className={classes.cardTitle}>{word.title}</h3>
        {word.pronunciation ? (
          <p className={classes.cardPronunciation}>[{word.pronunciation}]</p>
        ) : null}
        {word.definition ? (
          <p className={classes.cardDefinition}>{word.definition}</p>
        ) : null}
        <Link
          to={`/word/${encodeURIComponent(word.slug)}`}
          className={classes.learnMoreLink}
        >
          Learn More →
        </Link>
      </div>
    </div>
  );
};

WordCard.propTypes = {
  word: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    pronunciation: PropTypes.string,
    definition: PropTypes.string,
    image_url: PropTypes.string,
  }).isRequired,
  featured: PropTypes.bool,
};

WordCard.defaultProps = {
  featured: false,
};

export default WordCard;
